// import Profile from './Profile';

export default {
  priority: 10,
  exact: true,
  path: 'company-setting',
  permissions: ['isAdmin'],
  component: load(() => import(/* webpackChunkName: "Profile" */ './CompanySetting')),
  name: app.translate('routes.home.company-setting.Company Setting'),
  icon: 'account',
  drawer: false,
};
